/**
 * State related to zones
 */
export interface ZoneManagementState {
    /**
     * Whether it is creating zones from a selected route
     */
    isCreatingZoneFromRoute: boolean;
}

export const initialZoneManagementState: ZoneManagementState = {
    isCreatingZoneFromRoute: false
};
